import { isPreProdEnvironment } from "src/environmentInfo/EnvironmentInfo";
import { Role, User } from "../../auth/types/interfaces";
import { forbiddenResponse, successResponse } from "../constants";

export const loader = async (user: User) => {
  /**
   * Loader function for IPL pages
   *
   * @returns {Promise<Response>} A Promise that resolves with a Response object.
   *   Returns OK if user has IPL role and environment is not production
   *   Returns 404 not found if user doesn't have role or environment is production
   */
  if (isPreProdEnvironment() && user.roles.includes(Role.IPL_CLAIM_USER)) {
    return successResponse();
  } else {
    throw forbiddenResponse();
  }
};
